import axios from "axios";

const Geoserver = {
    server: {url: 'https://geoserver02.nilu.no'},
    LegendGraphic(layer, style, component) {
        return {
           url:  `${this.server.url}/geoserver/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=10&HEIGHT=10&LAYER=${layer}&STYLE=${style}_${component.toLowerCase()}`.trim()
        };
    },
    SingleMap(selections) {
        return {
           url:  `${this.server.url}/geoserver/iflink/wms?bbox={bbox-epsg-3857}
           &format=image/png
           &service=WMS
           &version=1.1.
           &request=GetMap
           &srs=EPSG:3857
           &transparent=true
           &width=256
           &height=256
           &layers=${selections.layer}
           &DIM_COMPONENT=${selections.component}
           &time=${selections.to}
           &styles=${selections.defaultstyle}_${selections.component.toLowerCase()}`.trim()
        }
    },
    SingleMapBbox(selections, time) {
         return {
           url:  `https://geoserver02.nilu.no/geoserver/iflink/wms?service=WMS
           &version=1.1.0
           &request=GetMap
           &layers=${selections.layer}
           &bbox=${selections.latlonboundingbox.minx}%2C${selections.latlonboundingbox.miny}%2C${selections.latlonboundingbox.maxx}%2C${selections.latlonboundingbox.maxy}
           &width=768
           &height=476
           &srs=EPSG%3A4326
           &format=image%2Fpng
           &DIM_COMPONENT=${selections.component}
           &time=${time}
           &transparent=true
           &styles=${selections.defaultstyle}_${selections.component.toLowerCase()}`.trim()
        }
    },
    downloadmapimage: function(selections){
        axios({
            url: this.SingleMapBbox(selections, selections.to).url,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
             var fileURL = window.URL.createObjectURL(new Blob([response.data]));
             var fileLink = document.createElement('a');

             fileLink.href = fileURL;
             fileLink.setAttribute('download', `${selections.layer}_${selections.to}.png`);
             document.body.appendChild(fileLink);

             fileLink.click();
        });
    }
             
 
};

export default Geoserver;
